<template>
<svg viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-TiJiaoXian`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.70166 3.91895C2.70166 2.81433 3.59711 1.91895 4.70166 1.91895H14.8638C15.9683 1.91895 16.8638 2.81433 16.8638 3.91895V14.0811C16.8638 15.1857 15.9683 16.0811 14.8638 16.0811H4.70166C3.59711 16.0811 2.70166 15.1857 2.70166 14.0811V3.91895ZM4.11377 4.33105C4.11377 3.77881 4.56146 3.33105 5.11377 3.33105H14.4517C15.004 3.33105 15.4517 3.77881 15.4517 4.33105V11.5985H4.11377V4.33105ZM4.11377 13.2421V13.6689C4.11377 14.2212 4.56146 14.6689 5.11377 14.6689H6.27197V13.2421H4.11377ZM7.97998 14.6689H11.5852V13.2421H7.97998V14.6689ZM13.2932 14.6689H14.4517C15.004 14.6689 15.4517 14.2212 15.4517 13.6689V13.2421H13.2932V14.6689Z" :fill="useCurrentColor ? 'currentColor' : '#1A1A1A'"/></svg>
</template>
<script>

export default {
  name: 'IconTiJiaoXian',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
